import Link from 'next/link'
import Image from 'next/image'
import ProductItem from '../Products/ProductItem'
import {useQuery} from 'react-query'
import GetFeaturedProducts from '@/services/api/products/GetFeaturedProducts'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Autoplay, Navigation} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import NewProductItem from '../Products/NewProductItem'
import { useTranslation } from 'next-i18next'
import useUserPreferences from '@/hooks/useUserPreferences';

interface Props {
  most_sold_products: any
}

export default function FeaturedProducts({most_sold_products}: Props) {
  const preferences = useUserPreferences();
  const { data: featured_products, isLoading, error } = useQuery(
    ['featured_products', preferences?.countryCode, preferences?.currencyCode],
    () => GetFeaturedProducts(preferences?.countryCode, preferences?.currencyCode),
    {
      enabled: !!preferences, // Only fetch when preferences are available
    }
  );
  const {t} = useTranslation('common')
  return (
    <div className="products container-fluid mx-auto mt-32 lg:mt-24">
      <h2 className="text-center text-success font-semibold text-3xl">
        {t('featuredProductsHeading')}
      </h2>
      {/*
       *<div className="products-list mt-6 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-4">
       */}
      <div className="products-list mt-6">
        <Swiper
          autoplay={{delay: 3000}}
          spaceBetween={10}
          modules={[Navigation, Autoplay]}
          navigation={true}
          breakpoints={{
            // when window width is >= 640px
            640: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1366: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}>
          {featured_products?.map((product: any, idx: number) => {
            return (
              <SwiperSlide key={idx}>
                <NewProductItem key={product.id} product={product} name="" gender="" />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className="browse-btn text-center">
        <Link
          href="/products"
          className="inline-block mt-6 border-2 border-primary text-primary text-center font-semibold rounded-lg px-12 py-[.9rem]">
          {t('viewMore')}
        </Link>
      </div>
    </div>
  )
}
